import React from "react";

import ListadoCompras from "../../components/Compras/ListaCompras";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchListadoCompras, FetchListadoRenovaciones, validarModuloRenovacion } from "../../redux/actions/aLogin";
import { ambienteAplicacion } from "../../constants/urls"
import { listarColoresFetch } from "../../redux/actions/aCotizacion";
import ListaRenovaciones from "../../components/Compras/ListaRenovaciones";
import ErrorPage from "../../components/ErrorPage";


class ContainerRenovacionesListado extends React.Component {

  async componentDidMount() {
    await this.props.listarColores();

    console.log('datosUsuarioVer', this.props.datosUsuarios)
    // await this.props.listadoDeRenovaciones(this.props.datosUsuarios.brokerCodigo,ambienteAplicacion);
  }

  render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {

              validarModuloRenovacion(this.props.datosUsuario.dataUsuario.usu_tipo_usuario) ?
              < ListaRenovaciones /> :
            <ErrorPage mainText="No tienes permisos para acceder a esta funcionalidad" secondaryText="Por favor, contacta al administrador si crees que esto es un error" />
            }

          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosUsuario: state.datosUsuarios,
});

const mapDispatchToProps = dispatch => {
  return {
    listarColores: () => dispatch(listarColoresFetch()),
    listadoDeRenovaciones: (param, ambiente) => dispatch(FetchListadoRenovaciones(param, ambiente)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerRenovacionesListado)
);
